import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDownload } from "../hooks/useDownload";
import { saveAs } from "file-saver";
import { useState } from "react";
import moment from "moment";
import Swal from "sweetalert2";

export const OrdenModalDownload = ({
  isVisible,
  values,
  onClose,
  onDiarioClick,
  disabled,
}) => {
  const { downloadExcel } = useDownload();
  const [isNormalLoading, setIsNormalLoading] = useState(false);
  const [isDetalladoLoading, setIsDetalladoLoading] = useState(false);

  const handleDownloadNormalClick = async () => {
    setIsNormalLoading(true);
    try {
      const response = await downloadExcel(
        values.fecha,
        values.campo,
        values.variedad,
        "normal"
      );
      saveAs(
        response,
        `ORDEN DE EMPAQUE ${moment(values.fecha).format("YYYY-MM-DD")}.xlsx`
      );
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal!",
        text: "Favor de comunicarlo con el equipo de desarrollo",
      });
      console.log(error);
    } finally {
      setIsNormalLoading(false);
      onClose();
    }
  };

  const handleDownloadDetalladoClick = async () => {
    setIsDetalladoLoading(true);
    if (values.campo === 0) {
      Swal.fire({
        icon: "error",
        title: "Favor de seleccionar un campo",
      });
      setIsDetalladoLoading(false);
      return;
    }

    try {
      const response = await downloadExcel(
        values.fecha,
        values.campo,
        values.variedad,
        "detallado"
      );
      saveAs(
        response,
        `ORDEN DE EMPAQUE CAMPO ${values.campo_name} ${moment(
          values.fecha
        ).format("YYYY-MM-DD")}.xlsx`
      );
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal!",
        text: "Favor de comunicarlo con el equipo de desarrollo",
      });
      console.log(error);
    } finally {
      setIsDetalladoLoading(false);
      onClose();
    }
  };

  return (
    <Modal isOpen={isVisible} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>Descargar excel</ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-4">
            <label>
              <FontAwesomeIcon icon="fa-solid fa-file-excel" color="#198754" />{" "}
              Reporte normal
            </label>
            <br />
            <div className="d-grid">
              <button
                className="btn btn-success"
                onClick={handleDownloadNormalClick}
                disabled={isNormalLoading || disabled}
              >
                {isNormalLoading ? (
                  <label>
                    <FontAwesomeIcon icon="fas fa-spinner" spin /> Descargar
                  </label>
                ) : (
                  "Descargar"
                )}
              </button>
            </div>
          </div>
          <div className="col-4">
            <label>
              <FontAwesomeIcon icon="fa-solid fa-file-excel" color="#198754" />{" "}
              Programa del día
            </label>
            <br />
            <div className="d-grid">
              <button
                className="btn btn-success"
                onClick={onDiarioClick}
                disabled={disabled}
              >
                Descargar
              </button>
            </div>
          </div>
          <div className="col-4">
            <label>
              <FontAwesomeIcon icon="fa-solid fa-file-excel" color="#198754" />{" "}
              Reporte detallado
            </label>
            <br />
            <div className="d-grid">
              <button
                className="btn btn-success"
                onClick={handleDownloadDetalladoClick}
                disabled={isDetalladoLoading || disabled}
              >
                {isDetalladoLoading ? (
                  <label>
                    <FontAwesomeIcon icon="fas fa-spinner" spin /> Descargar
                  </label>
                ) : (
                  "Descargar"
                )}
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
